// extracted by mini-css-extract-plugin
export default {"total":"ReceivablePublicAnnouncementBuildModal_total__5rCDk","document":"ReceivablePublicAnnouncementBuildModal_document__hoORm"};